// LLM generated - Model gpt-5.2-codex
import type { ComponentProps } from 'react';

import createModalsContext from '~/domains/common/context/createModalsContext';

import type { ConnectedPromotionBonusModal } from '../domains/promoCodes/components/PromotionBonusModal/ConnectedPromotionBonusModal';
import type { PromotionBonusModal } from '../domains/promoCodes/components/PromotionBonusModal/PromotionBonusModal';
import type WhalersClubDetailModal from '../domains/gamification/domains/whalersClub/components/WhalersClubDetailModal/WhalersClubDetailModal';
import type ConnectedWhalersClubRewardHistoryModal from '../domains/gamification/domains/whalersClub/components/ConnectedWhalersClubRewardHistoryModal/ConnectedWhalersClubRewardHistoryModal';
import type MissionStartedModal from '../domains/gamification/domains/missions/components/MissionStartedModal/MissionStartedModal';
import type ConnectedMissionCompletedModal from '../domains/gamification/domains/missions/components/MissionCompletedModal/ConnectedMissionCompletedModal';
import type { ConnectedPromoTermsModalPayload } from '../components/PromoTermsModal/ConnectedPromoTermsModal';

import type { SplitEntryPromoModal } from './contestPromoModals/SplitEntryPromoModal';
import type { MarketplacePromoModal } from './contestPromoModals/MarketplacePromoModal';

type PromoBonusModalType = {
  type: 'PromoBonusModal';
} & Omit<ComponentProps<typeof PromotionBonusModal>, 'onClose' | 'isOpen'>;

type PromoBonusModalWithRedeemType = {
  type: 'PromoBonusModalWithRedeem';
} & Omit<ComponentProps<typeof ConnectedPromotionBonusModal>, 'onClose' | 'isOpen'>;

type WhalersClubDetailModalType = {
  type: 'WhalersClubDetailModal';
} & Omit<ComponentProps<typeof WhalersClubDetailModal>, 'onClose' | 'isOpen'>;

type ConnectedWhalersClubRewardHistoryModalType = {
  type: 'ConnectedWhalersClubRewardHistoryModal';
} & Omit<ComponentProps<typeof ConnectedWhalersClubRewardHistoryModal>, 'onClose' | 'isOpen'>;

type PromoTermsModalType = {
  type: 'PromoTermsModal';
} & ConnectedPromoTermsModalPayload;

type MissionStartedModalType = {
  type: 'MissionStartedModal';
} & Omit<ComponentProps<typeof MissionStartedModal>, 'onClose' | 'isOpen'>;

type MissionCompletedModalType = {
  type: 'MissionCompletedModal';
} & Omit<ComponentProps<typeof ConnectedMissionCompletedModal>, 'onClose' | 'isOpen'>;

type ContestSplitEntryPromoModalType = {
  type: 'ContestSplitEntryPromoModal';
} & Omit<ComponentProps<typeof SplitEntryPromoModal>, 'onClose' | 'isOpen'>;

type ContestMarketplacePromoModalType = {
  type: 'ContestMarketplacePromoModal';
} & Omit<ComponentProps<typeof MarketplacePromoModal>, 'onClose' | 'isOpen'>;

type ModalType =
  | PromoBonusModalType
  | PromoBonusModalWithRedeemType
  | WhalersClubDetailModalType
  | ConnectedWhalersClubRewardHistoryModalType
  | PromoTermsModalType
  | MissionStartedModalType
  | MissionCompletedModalType
  | ContestSplitEntryPromoModalType
  | ContestMarketplacePromoModalType;

const { ModalsContext, ModalsContextProvider } = createModalsContext<ModalType>();

export {
  ModalsContext as PromotionsModalsContext,
  ModalsContextProvider as PromotionsModalsContextProvider,
};
